import React from "react";
import {
  BackTop,
  Button,
  Col,
  DatePicker,
  Divider,
  message,
  notification,
  Popconfirm,
  Radio,
  Row,
  Select,
  Spin,
  Table,
  Tooltip,
  Modal,
  Tag,
  Card,
  Tabs,
  Input,
  Dropdown,
  Menu,
} from "antd";
import { withRouter } from "react-router-dom";
import Icon, {
  ArrowUpOutlined,
  DeleteOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
  FormOutlined,
  LoadingOutlined,
  PrinterOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  maintenanceTeam,
  complaintSource,
  companyAll,
  complaint,
  complaintType,
  legalCompany,
  division,
  project,
  building,
  unit,
  contacts,
  priority,
} from "../../../constants/url";
import { Column, DualAxes } from "@ant-design/plots";
import { axiosInstance } from "../../../commons/commons";
import {
  decodedToken,
  encodedToken,
  stateStore,
} from "../../../constants/constants";
import moment from "moment";

class JobSearch extends React.Component {
  _isMounted = false;
  state = {
    companyData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    divisionData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    projectData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    buildingData: {
      list: [],
      selectedIndex: [],
      selectedValue: [],
      disabled: false,
    },
    unitData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    jobOrderNo: {
      selectedValue: null,
    },
    remarks: {
      selectedValue: null,
    },
    jobOrderDateFrom: {
      selectedValue: null,
    },
    expStartDateFrom: {
      selectedValue: null,
    },
    expEndDateFrom: {
      selectedValue: null,
    },
    jobOrderDateTo: {
      selectedValue: null,
    },
    expStartDateTo: {
      selectedValue: null,
    },
    expEndDateTo: {
      selectedValue: null,
    },
    jobScopeData: {
      list: ["AMC", "NON_AMC"],
      selectedIndex: null,
      selectedValue: null,
    },
    teamData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    technicianData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    complaintTypeData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    priorityData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    complaintSourceData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    customerData: {
      list: [],
      selectedIndex: null,
      selectedValue: null,
    },
    tableData: {
      list: [],
      filterData: [],
      selectedIndex: null,
      selectedValue: null,
      // currentPage: 1,
      currentPage: { 0: 1, 1: 1, 2: 1, 3: 1, 4: 1 },
      pageSize: 20,
      total: 20,
    },
    tabData: { activeKey: "0" },
    dualVisualizationData: [],
    multipleVisualizationData: [],
    modalIsVisible: false,
    tableIsLoading: true,
    reportURL: "http://www.orimi.com/pdf-test.pdf",
    printIsDisabled: true,
    printDataLoading: false,
    reportViewerIsHidden: true,
    contactCompanyRadio: null,
    delNotAllRadio: "notdeleted",
    userDevice:
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
        ? "mobile"
        : "pc",
    parent: null,
  };

  labelStyle = { marginLeft: "10%" };
  inputStyle = { width: "90%", marginLeft: 10 };
  colResponse = { xs: 18, sm: 18, md: 14, lg: 14 };

  fieldsToValidate = [];
  reportViewerRef = null;
  tableRef = null;
  controller = new AbortController();

  columns = [
    {
      title: "Job Order No.",
      width: 100,
      dataIndex: "ComplaintNo",
      key: "jobOrderNo",
      align: "center",
      fixed: "left",
      sorter: (a, b) =>
        (a.ComplaintNo || "").localeCompare(b.ComplaintNo || ""),
      // render: value=>{}
    },
    {
      title: "Job Order Date",
      width: 100,
      dataIndex: "ComplaintDate",
      key: "jobOrderDate",
      align: "center",
      fixed: "left",
      sorter: (a, b) => new Date(a.ComplaintDate) - new Date(b.ComplaintDate),
      render: (value) => {
        return (value || "").slice(0, 16).replace("T", " ");
      },
    },
    {
      title: "Building",
      width: 100,
      key: "building",
      dataIndex: ["Building", "BuildingName"],
      align: "center",
      sorter: (a, b) =>
        ((a.Building || {}).BuildingName || "").localeCompare(
          (b.Building || {}).BuildingName || ""
        ),
      // render: value=>{}
    },
    {
      title: "Unit",
      width: 100,
      key: "Unit",
      dataIndex: ["Unit", "UnitNo"],
      align: "center",
      sorter: (a, b) =>
        ((a.Unit || {}).UnitNo || "").localeCompare(
          (b.Unit || {}).UnitNo || ""
        ),
      // render: value=>{}
    },
    {
      title: "Complaint Type",
      width: 100,
      key: "ComplaintType",
      dataIndex: ["ComplaintType", "UserName"],
      align: "center",
      sorter: (a, b) =>
        ((a.ComplaintType || {}).UserName || "").localeCompare(
          (b.ComplaintType || {}).UserName || ""
        ),
      // render: value=>{}
    },
    {
      title: "Customer",
      width: 100,
      dataIndex: ["TC", "Customer"],
      key: "customer",
      align: "center",
      sorter: (a, b) =>
        ((a.TC || {}).Customer || "").localeCompare(
          (b.TC || {}).Customer || ""
        ),
      // render: value=>{}
    },
    // {
    //   title: "Job Scope",
    //   width: 100,
    //   dataIndex: "JobOrderType",
    //   key: "jobScope",
    //   align: "center",
    //   // render: value=>{}
    // },
    // {
    //   title: "Scope Sub Type",
    //   width: 100,
    //   dataIndex: "JobRepeatNew",
    //   key: "scopeSubType",
    //   align: "center",
    //   // render: value=>{}
    // },
    {
      title: "Priority",
      width: 100,
      dataIndex: "Priority",
      key: "priority",
      align: "center",
      sorter: (a, b) => (a.Priority || "").localeCompare(b.Priority || ""),
      render: (value) =>
        value ? (
          <Tag
            color={
              ["Low", "Medium"].includes(value)
                ? "yellow"
                : ["High", "Critical"].includes(value)
                ? "red"
                : "green"
            }
            style={{ borderRadius: 20 }}
          >
            {value}
          </Tag>
        ) : (
          value
        ),
    },
    {
      title: "Main Status",
      width: 100,
      dataIndex: "OpenClosed",
      key: "mainStatus",
      align: "center",
      sorter: (a, b) => (a.OpenClosed || "").localeCompare(b.OpenClosed || ""),
      render: (value) =>
        value ? (
          <Tag
            color={value === "Open" ? "red" : "green"}
            style={{ borderRadius: 20 }}
          >
            {value}
          </Tag>
        ) : (
          value
        ),
    },
    // {
    //   title: "Maintenance Status",
    //   width: 100,
    //   dataIndex: "Maintenance_Status",
    //   key: "Maintenance_Status",
    //   align: "center",
    //   render: (value) => (value && value !== "0" ? value : ""),
    // },
    {
      title: "Sub Status",
      width: 100,
      key: "subStatus",
      dataIndex: ["ComplaintStatus", "UserName"],
      align: "center",
      sorter: (a, b) =>
        ((a.ComplaintStatus || {}).UserName || "").localeCompare(
          (b.ComplaintStatus || {}).UserName || ""
        ),
      // render: value=>{}
    },
    {
      title: "Closed Date",
      width: 100,
      dataIndex: "DateEdited",
      key: "DateEdited",
      align: "center",
      fixed: "left",
      sorter: (a, b) => new Date(a.DateEdited) - new Date(b.DateEdited),
      render: (value, record) => {
        return record.OpenClosed === "Closed"
          ? (value || "").slice(0, 16).replace("T", " ")
          : "";
      },
    },
    // {
    //   title: "Location Name",
    //   width: 100,
    //   key: "locationName",
    //   dataIndex: "LocationName",
    //   align: "center",
    //   // render: value=>{}
    // },
    // {
    //   title: "Sub Location Name",
    //   width: 100,
    //   key: "subLocationName",
    //   dataIndex: ["AssetSubLocation", "SubLocationName"],
    //   align: "center",
    //   // render: value=>{}
    // },
    // {
    //   title: "Team Name",
    //   width: 100,
    //   key: "teamName",
    //   dataIndex: ["MaintenanceTeam", "TeamName"],
    //   align: "center",
    //   // render: value=>{}
    // },
    {
      title: "Supervisor",
      width: 100,
      key: "technician",
      dataIndex: ["Supervisor", "ContactName"],
      align: "center",
      sorter: (a, b) =>
        ((a.Supervisor || {}).ContactName || "").localeCompare(
          (b.Supervisor || {}).ContactName || ""
        ),
      // render: value=>{}
    },
    // {
    //   title: "Complaint Source",
    //   width: 100,
    //   dataIndex: "ProblemOrigin",
    //   key: "complaintSource",
    //   align: "center",
    //   // render: value=>{}
    // },
    // {
    //   title: "Created through",
    //   width: 100,
    //   dataIndex: "CreatedThroughWeb",
    //   key: "CreatedThroughWeb",
    //   align: "center",
    //   render: (value) => (value ? "Web" : "Desktop"),
    // },
    {
      title: "Remarks",
      width: 100,
      dataIndex: "Remarks",
      key: "remarks",
      align: "center",
      sorter: (a, b) => (a.Remarks || "").localeCompare(b.Remarks || ""),
      // render: value=>{}
    },
    {
      title: "Action",
      width: 80,
      key: "action",
      fixed: "right",
      align: "center",
      render: (_, item) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
            }}
          >
            <FormOutlined
              style={{ color: "#1890ff" }}
              disabled={
                decodedToken.value.User_ID !== 1 &&
                stateStore.permissions[69] &&
                stateStore.permissions[69].UEdit === "N"
              }
              onClick={(e) => {
                if (
                  decodedToken.value.User_ID !== 1 &&
                  stateStore.permissions[69] &&
                  stateStore.permissions[69].UEdit === "N"
                )
                  return message.warning(
                    "No permission to perform this action!"
                  );
                // stateStore.jobSearch = {
                //   ...this.state,
                //   printDataLoading: false,
                //   printIsDisabled: false,
                //   reportViewerIsHidden: true,
                // };
                if (stateStore.navAble)
                  stateStore.navAble({
                    defaultSelectedKeys: ["jobRegistration"],
                    routableProps: {
                      state: { ComplaintID: item.ComplaintID },
                    },
                  });
              }}
            />
            <Popconfirm
              title="Are you sure to delete ?"
              onConfirm={(e) => {
                if (
                  decodedToken.value.User_ID !== 1 &&
                  (!stateStore.permissions[65] ||
                    stateStore.permissions[65].UDelete === "N")
                )
                  return message.warning(
                    "No permission to perform this action!"
                  );
                axiosInstance
                  .delete(complaint + "/" + item.ComplaintID)
                  .then((res) => {
                    if (res.data.success)
                      notification.success({
                        message: "Success",
                        description:
                          "Complaint ID: " + item.ComplaintID + " deleted !",
                      });
                    else
                      notification.success({
                        duration: 3,
                        message: "Fail",
                        description:
                          res.data.message || "Something went wrong!",
                      });
                    this.onSearchClicked();
                  })
                  .catch(() => {});
              }}
              // onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <DeleteOutlined
                style={{ color: "red" }}
                disabled={
                  decodedToken.value.User_ID !== 1 &&
                  (!stateStore.permissions[65] ||
                    stateStore.permissions[65].UDelete === "N")
                }
              />
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  getInitialState = async () => {
    let state = {
      companyData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      divisionData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      projectData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      buildingData: {
        list: [],
        selectedIndex: [],
        selectedValue: [],
        disabled: false,
      },
      unitData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      jobOrderNo: {
        selectedValue: null,
      },
      remarks: {
        selectedValue: null,
      },
      jobOrderDateFrom: {
        selectedValue: null,
      },
      jobOrderDateTo: {
        selectedValue: null,
      },
      expStartDateFrom: {
        selectedValue: null,
      },
      expEndDateFrom: {
        selectedValue: null,
      },
      expStartDateTo: {
        selectedValue: null,
      },
      expEndDateTo: {
        selectedValue: null,
      },
      jobScopeData: {
        list: ["AMC", "NON_AMC"],
        selectedIndex: null,
        selectedValue: null,
      },
      teamData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      technicianData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      complaintTypeData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      priorityData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      complaintSourceData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      customerData: {
        list: [],
        selectedIndex: null,
        selectedValue: null,
      },
      tableData: {
        list: [],
        filterData: [],
        selectedIndex: null,
        selectedValue: null,
        currentPage: { 0: 1, 1: 1, 2: 1, 3: 1, 4: 1 },
        pageSize: 20,
        total: 20,
      },
      tabData: { activeKey: "0" },
      dualVisualizationData: [],
      multipleVisualizationData: [],
      modalIsVisible: false,
      tableIsLoading: false,
      reportURL: "http://www.orimi.com/pdf-test.pdf",
      printIsDisabled: true,
      printDataLoading: false,
      contactCompanyRadio: null,
      reportViewerIsHidden: true,
      delNotAllRadio: "notdeleted",
      userDevice:
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
          ? "mobile"
          : "pc",
      parent: "jobRegistration",
    };
    await axiosInstance
      .get(legalCompany)
      .then((res) => {
        if (res.data.success) state.companyData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance
      .get(complaintType)
      .then((res) => {
        if (res.data.success) state.complaintTypeData.list = res.data.message;
      })
      .catch(() => {});
    await axiosInstance.get(priority).then((res) => {
      if (res.data.success) state.priorityData.list = res.data.message;
    });
    await axiosInstance
      .get(contacts + "?categoryName=Employee")
      .then((res) => {
        if (res.data.success)
          state.technicianData.list = res.data.message.rows || [];
      })
      .catch(() => {});
    await axiosInstance
      .get(
        building +
          (decodedToken.value.ContactID && decodedToken.value.Role_ID !== 1
            ? "?incharge_id=" + decodedToken.value.ContactID
            : "")
      )
      .then((res) => {
        if (res.data.success) {
          state.buildingData = {
            list: res.data.message,
            selectedIndex: [],
            selectedValue: [],
          };
          res.data.message.map((bldg, index) => {
            if (
              bldg.incharge_id === decodedToken.value.ContactID
              // || decodedToken.value.Role_ID === 1
            ) {
              state.buildingData.selectedIndex.push(index);
              state.buildingData.selectedValue.push(bldg.BuildingID);
            }
            return bldg;
          });
        }
      })
      .catch(() => {});
    return state;
  };

  onBuildingChange = (buildingIDs) => {
    this.setState(
      {
        buildingData: {
          list: this.state.buildingData.list,
          selectedIndex: this.state.buildingData.selectedIndex,
          selectedValue: buildingIDs,
          disabled: this.state.buildingData.disabled,
        },
        unitData: {
          list: [],
          selectedIndex: null,
          selectedValue: null,
          icon: buildingIDs.length ? (
            <LoadingOutlined style={{ color: "#1890ff" }} />
          ) : null,
        },
      },
      async () => {
        if (buildingIDs.length)
          await axiosInstance
            .get(
              unit +
                "?BuildingID=" +
                buildingIDs.join(",") +
                "&RentalUnitsubStatusID=2"
            )
            .then((res) => {
              if (res.data.success)
                this.setState({
                  unitData: {
                    list: res.data.message,
                    selectedIndex: null,
                    selectedValue: null,
                  },
                });
            })
            .catch(() => {
              this.setState({
                unitData: {
                  list: [],
                  selectedIndex: null,
                  selectedValue: null,
                },
              });
            });
      }
    );
  };

  onChange = (value) => {
    if (value && value.target) {
      switch (value.target.value) {
        case "deleted":
        case "notdeleted":
        case "allstatus":
          this.setState({ delNotAllRadio: value.target.value });
          break;
        case "contact":
          this.setState({
            contactCompanyRadio: value.target.value,
            customerData: {
              list: this.state.customerData.list,
              selectedIndex: this.state.customerData.selectedIndex,
              selectedValue: this.state.customerData.selectedValue,
              icon: <LoadingOutlined style={{ color: "#1890ff" }} />,
            },
          });
          axiosInstance
            .get(contacts)
            // .get(contacts + "?ContactCategoryID=2&ContactSubCategoryID=2")
            .then((res) => {
              if (res.data.success)
                this.setState({
                  customerData: {
                    list: res.data.message.rows,
                    selectedIndex: null,
                    selectedValue: null,
                  },
                });
              else
                notification.success({
                  duration: 3,
                  message: "Fail",
                  description: res.data.message || "Something went wrong!",
                });
            })
            .catch(() => {});
          break;
        case "company":
          this.setState({ contactCompanyRadio: value.target.value });
          axiosInstance
            .get(companyAll)
            .then((res) => {
              if (res.data.success)
                this.setState({
                  customerData: {
                    list: res.data.message.rows,
                    selectedIndex: null,
                    selectedValue: null,
                  },
                });
              else
                notification.success({
                  duration: 3,
                  message: "Fail",
                  description: res.data.message || "Something went wrong!",
                });
            })
            .catch(() => {});
          break;
        default:
          break;
      }
      return;
    }
    let theIndex = value.split("+-")[1];
    let theValue = value.split("+-")[2];
    switch (value.split("+-")[0]) {
      case "adminCompany":
        this.setState(
          {
            companyData: {
              list: this.state.companyData.list,
              selectedIndex: theIndex,
              selectedValue: value,
            },
            divisionData: {
              list: [],
              selectedIndex: null,
              selectedValue: null,
              icon: theValue ? (
                <LoadingOutlined style={{ color: "#1890ff" }} />
              ) : null,
            },
            projectData: {
              list: [],
              selectedIndex: null,
              selectedValue: null,
            },
            buildingData: {
              list: [],
              selectedIndex: null,
              selectedValue: null,
            },
            unitData: {
              list: [],
              selectedIndex: null,
              selectedValue: null,
            },
          },
          () => {
            if (theValue)
              axiosInstance
                .get(
                  division +
                    "?LegalCompanyID=" +
                    this.state.companyData.list[theIndex].LegalCompanyID
                )
                .then((res) => {
                  if (res.data.success)
                    this.setState({
                      divisionData: {
                        list: res.data.message,
                        selectedIndex: null,
                        selectedValue: null,
                      },
                    });
                })
                .catch(() => {});
          }
        );
        break;
      case "division":
        this.setState(
          {
            divisionData: {
              list: this.state.divisionData.list,
              selectedIndex: theIndex,
              selectedValue: value,
            },
            projectData: {
              list: [],
              selectedIndex: null,
              selectedValue: null,
              icon: theValue ? (
                <LoadingOutlined style={{ color: "#1890ff" }} />
              ) : null,
            },
            buildingData: {
              list: [],
              selectedIndex: null,
              selectedValue: null,
            },
            unitData: {
              list: [],
              selectedIndex: null,
              selectedValue: null,
            },
          },
          () => {
            if (theValue)
              axiosInstance
                .get(
                  project +
                    "?DivisionID=" +
                    this.state.divisionData.list[theIndex].DivisionID
                )
                .then((res) => {
                  if (res.data.success)
                    this.setState({
                      projectData: {
                        list: res.data.message,
                        selectedIndex: null,
                        selectedValue: null,
                      },
                    });
                })
                .catch(() => {});
          }
        );
        break;
      case "project":
        this.setState(
          {
            projectData: {
              list: this.state.projectData.list,
              selectedIndex: theIndex,
              selectedValue: value,
            },
            buildingData: {
              list: [],
              selectedIndex: null,
              selectedValue: null,
              icon: theValue ? (
                <LoadingOutlined style={{ color: "#1890ff" }} />
              ) : null,
            },
            unitData: {
              list: [],
              selectedIndex: null,
              selectedValue: null,
            },
          },
          () => {
            if (theValue)
              axiosInstance
                .get(
                  building +
                    "?ProjectID=" +
                    this.state.projectData.list[theIndex].ProjectID
                )
                .then((res) => {
                  if (res.data.success)
                    this.setState({
                      buildingData: {
                        list: res.data.message,
                        selectedIndex: null,
                        selectedValue: null,
                      },
                    });
                })
                .catch(() => {});
          }
        );
        break;
      case "building":
        break;
        this.setState(
          {
            buildingData: {
              list: this.state.buildingData.list,
              selectedIndex: theIndex,
              selectedValue: value,
            },
            unitData: {
              list: [],
              selectedIndex: null,
              selectedValue: null,
              icon: theValue ? (
                <LoadingOutlined style={{ color: "#1890ff" }} />
              ) : null,
            },
          },
          () => {
            if (theValue)
              axiosInstance
                .get(
                  unit +
                    "?BuildingID=" +
                    this.state.buildingData.list[theIndex].BuildingID +
                    "&RentalUnitsubStatusID=2"
                )
                .then((res) => {
                  if (res.data.success)
                    this.setState({
                      unitData: {
                        list: res.data.message,
                        selectedIndex: null,
                        selectedValue: null,
                      },
                    });
                })
                .catch(() => {});
          }
        );
        break;
      case "unit":
        this.setState({
          unitData: {
            list: this.state.unitData.list,
            selectedIndex: theIndex,
            selectedValue: value,
          },
        });
        break;
      case "team":
        this.setState(
          {
            teamData: {
              list: this.state.teamData.list,
              selectedIndex: theIndex,
              selectedValue: value,
            },
          },
          () => {
            if (theValue)
              this.setState({
                technicianData: {
                  list: this.state.teamData.list[theIndex]
                    .MaintenanceTeamEmployees,
                  selectedIndex: null,
                  selectedValue: null,
                },
              });
          }
        );
        break;
      case "employee":
        this.setState({
          technicianData: {
            list: this.state.technicianData.list,
            selectedIndex: theIndex,
            selectedValue: value,
          },
        });
        break;
      case "complaintType":
        this.setState({
          complaintTypeData: {
            list: this.state.complaintTypeData.list,
            selectedIndex: theIndex,
            selectedValue: value,
          },
        });
        break;
      case "priority":
        this.setState({
          priorityData: {
            list: this.state.priorityData.list,
            selectedIndex: theIndex,
            selectedValue: value,
          },
        });
        break;
      case "source":
        this.setState({
          complaintSourceData: {
            list: this.state.complaintSourceData.list,
            selectedIndex: theIndex,
            selectedValue: value,
          },
        });
        break;
      case "scope":
        this.setState({
          jobScopeData: {
            list: this.state.jobScopeData.list,
            selectedIndex: theIndex,
            selectedValue: value,
          },
        });
        break;
      case "customer":
        this.setState({
          customerData: {
            list: this.state.customerData.list,
            selectedIndex: theIndex,
            selectedValue: value,
          },
        });
        break;
      default:
        break;
    }
  };

  onDateChange = (obj) => {
    this.setState(obj);
  };

  parseSearchQueries = () => {
    const lists = {};
    lists.BuildingID = this.state.buildingData.selectedValue.join(",");
    lists.BuildingID = lists.BuildingID ? lists.BuildingID : undefined;
    lists.UnitID = this.state.unitData.list[this.state.unitData.selectedIndex];
    lists.UnitID = lists.UnitID ? lists.UnitID.UnitID : undefined;
    lists.ComplaintDateFrom = this.state.jobOrderDateFrom.selectedValue
      ? this.state.jobOrderDateFrom.selectedValue
          .clone()
          .add(1, "day")
          .toISOString()
          .split("T")[0]
      : undefined;
    lists.ComplaintDateTo = this.state.jobOrderDateTo.selectedValue
      ? this.state.jobOrderDateTo.selectedValue
          .clone()
          .add(1, "day")
          .toISOString()
          .split("T")[0]
      : undefined;
    // if (lists.ComplaintDateFrom) {
    //   if (!lists.ComplaintDateTo) {
    //     lists.ComplaintDateTo = new Date().toISOString().split("T")[0];
    //   }
    // }
    // if (lists.ComplaintDateTo) {
    //   if (!lists.ComplaintDateFrom) {
    //     return this.setState({
    //       tableIsLoading: false,
    //     });
    //   }
    // }
    lists.ComplaintNo = this.state.jobOrderNo.selectedValue || undefined;
    lists.Remarks = this.state.remarks.selectedValue || undefined;
    lists.ComplaintTypeID =
      this.state.complaintTypeData.list[
        this.state.complaintTypeData.selectedIndex
      ];
    lists.ComplaintTypeID = lists.ComplaintTypeID
      ? lists.ComplaintTypeID.ComplaintTypeID
      : undefined;
    lists.SupervisorID =
      this.state.technicianData.list[this.state.technicianData.selectedIndex];
    lists.SupervisorID = lists.SupervisorID
      ? lists.SupervisorID.ContactID
      : undefined;
    lists.Priority =
      this.state.priorityData.list[this.state.priorityData.selectedIndex];
    lists.Priority = lists.Priority ? lists.Priority.UserName : undefined;
    lists.Deleted =
      this.state.delNotAllRadio === "deleted"
        ? true
        : this.state.delNotAllRadio === "notdeleted"
        ? false
        : undefined;
    if (this.state.contactCompanyRadio)
      if (this.state.contactCompanyRadio === "contact") {
        lists.ContactID =
          this.state.customerData.list[this.state.customerData.selectedIndex];
        lists.ContactID = lists.ContactID
          ? lists.ContactID.ContactID
          : undefined;
      } else {
        lists.CompanyID =
          this.state.customerData.list[this.state.customerData.selectedIndex];
        lists.CompanyID = lists.CompanyID
          ? lists.CompanyID.CompanyID
          : undefined;
      }
    switch (this.state.tabData.activeKey) {
      case "0":
        lists.Viewed = false;
        lists.OpenClosed = "Open";
        // lists.ComplaintStatus = "Not Assigned";
        // lists.ComplaintStatusID = 1;
        break;
      case "1":
        lists.OpenClosed = "Open";
        lists.ComplaintStatus = "Under Process";
        // lists.ComplaintStatusID = 1;
        break;
      case "2":
        lists.OpenClosed = "Closed";
        lists.ComplaintStatus = "Rejected";
        // lists.ComplaintStatusID = 8;
        break;
      case "3":
        lists.OpenClosed = "Closed";
        // lists.ComplaintStatus = "Completed";
        // lists.ComplaintStatusID = 2;
        break;
      default:
        break;
    }
    return lists;
  };

  onSearchClicked = () => {
    this.setState({
      tableIsLoading: true,
      modalIsVisible: false,
    });
    let query = "?";
    const lists = { ...this.parseSearchQueries() };
    lists.offset =
      (this.state.tableData.currentPage[this.state.tabData.activeKey] - 1) *
      this.state.tableData.pageSize;
    lists.limit = this.state.tableData.pageSize;
    for (let key in lists) {
      query += lists[key] !== undefined ? key + "=" + lists[key] + "&" : "";
    }
    query = query.length > 1 ? query.slice(0, query.length - 1) : "";
    axiosInstance
      .get(complaint + query)
      .then((res) => {
        if (res.data.success) {
          let state = this.state;
          state.tableData.selectedIndex = null;
          state.tableData.selectedValue = null;
          state.tableData.total = res.data.message.count;
          state.tableData.list = res.data.message.rows
            .map((complaint, index) => {
              complaint.key = index;
              complaint.SN = lists.offset + 1 + index;
              complaint.reportGroup = "1";
              return complaint;
              // filter data for default selected tab/complaint-status
              switch (state.tabData.activeKey) {
                case "0": // new request not yet viewed
                  if (
                    (complaint.ComplaintStatus || {}).UserName ===
                    "Not Assigned"
                  )
                    return complaint;
                  // if (!complaint.Viewed) return complaint;
                  break;
                case "1": // in progress (MainStatus=Open, SubStatus='Under Progress')
                  if (
                    complaint.OpenClosed === "Open" &&
                    // Under Process
                    // complaint.ComplaintStatusID === 1

                    (complaint.ComplaintStatus || {}).UserName ===
                      "Under Process"
                  )
                    return complaint;
                  break;
                case "2": // rejected
                  if (
                    complaint.OpenClosed === "Closed" &&
                    // not Completed
                    complaint.ComplaintStatusID !== 4
                  )
                    return complaint;
                  break;
                case "3":
                  if (
                    complaint.OpenClosed === "Closed" &&
                    // Under Process
                    complaint.ComplaintStatusID === 4
                  )
                    return complaint;
                  break;
                default:
                  return complaint;
              }
              return null;
            })
            .filter(Boolean);
          state.tableIsLoading = false;
          state.printIsDisabled = !res.data.message.rows.length;
          state.reportViewerIsHidden = true;
          stateStore.jobSearch = {
            ...state,
            printDataLoading: false,
            printIsDisabled: false,
            reportViewerIsHidden: true,
          };
          this.setState(state, () => {
            if (this.tableRef)
              this.tableRef.scrollIntoView({ behavior: "smooth" });
          });
          // notification.success({
          //   message: "Success",
          //   description:
          //     (res.data.message.rows.length || "No") + " record(s) found !",
          // });
        } else
          notification.success({
            duration: 3,
            message: "Fail",
            description: res.data.message || "Something went wrong!",
          });
      })
      .catch(() => {
        this.setState({
          tableIsLoading: false,
        });
      });
  };

  onReset = async () => {
    this.setState(await this.getInitialState(), () => {
      this.onBuildingChange(this.state.buildingData.selectedValue);
      this.onSearchClicked();
    });
  };

  componentDidMount() {
    this._isMounted = true;
    this.controller = new AbortController();
    if (
      decodedToken.value.activeKey === "employee" &&
      decodedToken.value.User_ID !== 1 &&
      stateStore.permissions[65] &&
      stateStore.permissions[65].UView === "N"
    )
      if (stateStore.navAble)
        stateStore.navAble({
          defaultSelectedKeys: ["dashboard"],
        });
    if (stateStore.jobSearch) {
      stateStore.jobSearch.parent =
        this.props.location.caller || "jobRegistration";
      stateStore.jobSearch.tabData.activeKey = (
        (this.props.location || {}).state || {}
      ).activeKey;
      if (!stateStore.jobSearch.tabData.activeKey) {
        stateStore.jobSearch.tabData.activeKey = "0";
      }
      if (((this.props.location || {}).state || {}).category) {
        //reset previously applied filters
        stateStore.jobSearch.buildingData.selectedIndex = [];
        stateStore.jobSearch.buildingData.selectedValue = [];
        stateStore.jobSearch.unitData.selectedIndex = null;
        stateStore.jobSearch.unitData.selectedValue = null;
        stateStore.jobSearch.jobOrderNo = {
          selectedValue: null,
        };
        stateStore.jobSearch.jobOrderDateFrom = {
          selectedValue: null,
        };
        stateStore.jobSearch.jobOrderDateTo = {
          selectedValue: null,
        };
        stateStore.jobSearch.complaintTypeData.selectedIndex = null;
        stateStore.jobSearch.complaintTypeData.selectedValue = null;
        stateStore.jobSearch.priorityData.selectedIndex = null;
        stateStore.jobSearch.priorityData.selectedValue = null;
        stateStore.jobSearch.technicianData.selectedIndex = null;
        stateStore.jobSearch.technicianData.selectedValue = null;
        stateStore.jobSearch.remarks = {
          selectedValue: null,
        };
        stateStore.jobSearch.delNotAllRadio = "notdeleted";
        stateStore.jobSearch.contactCompanyRadio = "notdeleted";
        stateStore.jobSearch.customerData.selectedIndex = null;
        stateStore.jobSearch.customerData.selectedValue = null;
        stateStore.jobSearch.tableData = {
          list: [],
          filterData: [],
          selectedIndex: null,
          selectedValue: null,
          currentPage: { 0: 1, 1: 1, 2: 1, 3: 1, 4: 1 },
          pageSize: 20,
          total: 20,
        };
        if (((this.props.location || {}).state || {}).date) {
          if (this.props.location.state.date[0])
            stateStore.jobSearch.jobOrderDateFrom.selectedValue = moment(
              this.props.location.state.date[0]
            );
          if (this.props.location.state.date[1])
            stateStore.jobSearch.jobOrderDateTo.selectedValue = moment(
              this.props.location.state.date[1]
            );
        }
        switch (this.props.location.state.category) {
          case "building":
            axiosInstance
              .get(building + "?dashboard=true")
              .then((res) => {
                if (res.data.success) {
                  stateStore.jobSearch.buildingData = {
                    list: res.data.message,
                    selectedIndex: [],
                    selectedValue: [],
                  };
                  stateStore.jobSearch.buildingData.list.map(
                    (building, index) => {
                      if (
                        String(building.BuildingID) ===
                        this.props.location.state.id
                        // building.BuildingName ===
                        // this.props.location.state.subCategory
                      ) {
                        stateStore.jobSearch.buildingData.selectedIndex = [
                          index,
                        ];
                        stateStore.jobSearch.buildingData.selectedValue =
                          // "building+-" + index + "+-" +
                          [building.BuildingID];
                      }
                      return building;
                    }
                  );
                }
                this.setState(stateStore.jobSearch, this.onSearchClicked);
              })
              .catch(() => {
                this.setState(stateStore.jobSearch, this.onSearchClicked);
              });
            break;
          case "technician":
            for (let team of stateStore.jobSearch.teamData.list) {
              stateStore.jobSearch.technicianData.list = [
                ...stateStore.jobSearch.technicianData.list,
                ...(team.MaintenanceTeamEmployees || []),
              ];
            }
            stateStore.jobSearch.technicianData.list.map(
              (technician, index) => {
                if (
                  String(technician.ContactID) === this.props.location.state.id
                  // technician.Contact.ContactName ===
                  // this.props.location.state.subCategory
                ) {
                  stateStore.jobSearch.technicianData.selectedIndex = index;
                  stateStore.jobSearch.technicianData.selectedValue =
                    "employee+-" + index + "+-" + technician.ContactName;
                }
                return technician;
              }
            );
            this.setState(stateStore.jobSearch, this.onSearchClicked);
            break;
          case "complaintType":
            stateStore.jobSearch.complaintTypeData.list.map((type, index) => {
              if (
                String(type.ComplaintTypeID) === this.props.location.state.id
              ) {
                stateStore.jobSearch.complaintTypeData.selectedIndex = index;
                stateStore.jobSearch.complaintTypeData.selectedValue =
                  "complaintType+-" + index + "+-" + type.SysName;
              }
              return type;
            });
            this.setState(stateStore.jobSearch, this.onSearchClicked);
            break;
          case "priority":
            stateStore.jobSearch.priorityData.list.map((priority, index) => {
              if (priority.UserName === this.props.location.state.subCategory) {
                stateStore.jobSearch.priorityData.selectedIndex = index;
                stateStore.jobSearch.priorityData.selectedValue =
                  "priority+-" + index + "+-" + priority.UserName;
              }
              return priority;
            });
            this.setState(stateStore.jobSearch, this.onSearchClicked);
            break;
          default:
            this.setState(stateStore.jobSearch, this.onSearchClicked);
            break;
        }
      } else this.setState(stateStore.jobSearch, this.onSearchClicked);
    } else
      this.getInitialState().then(async (state) => {
        state.parent = this.props.location.caller || "jobRegistration";
        if (((this.props.location || {}).state || {}).category) {
          if (((this.props.location || {}).state || {}).date) {
            if (this.props.location.state.date[0])
              state.jobOrderDateFrom.selectedValue = moment(
                this.props.location.state.date[0]
              );
            if (this.props.location.state.date[1])
              state.jobOrderDateTo.selectedValue = moment(
                this.props.location.state.date[1]
              );
          }
          switch (this.props.location.state.category) {
            case "building":
              state.buildingData.list.map((building, index) => {
                if (
                  String(building.BuildingID) === this.props.location.state.id
                ) {
                  state.buildingData.selectedIndex = [index];
                  state.buildingData.selectedValue = [building.BuildingID];
                }
                return building;
              });
              break;
            case "technician":
              for (let team of state.teamData.list) {
                state.technicianData.list = [
                  ...state.technicianData.list,
                  ...(team.MaintenanceTeamEmployees || []),
                ];
              }
              state.technicianData.list.map((technician, index) => {
                if (
                  String(technician.ContactID) === this.props.location.state.id
                ) {
                  state.technicianData.selectedIndex = index;
                  state.technicianData.selectedValue =
                    "employee+-" + index + "+-" + technician.ContactName;
                }
                return technician;
              });
              break;
            case "complaintType":
              state.complaintTypeData.list.map((type, index) => {
                if (
                  String(type.ComplaintTypeID) === this.props.location.state.id
                ) {
                  state.complaintTypeData.selectedIndex = index;
                  state.complaintTypeData.selectedValue =
                    "complaintType+-" + index + "+-" + type.SysName;
                }
                return type;
              });
              break;
            case "priority":
              state.priorityData.list.map((priority, index) => {
                if (
                  priority.UserName === this.props.location.state.subCategory
                ) {
                  state.priorityData.selectedIndex = index;
                  state.priorityData.selectedValue =
                    "priority+-" + index + "+-" + priority.UserName;
                }
                return priority;
              });
              break;
            default:
              break;
          }
        }
        if (this._isMounted) {
          state.tabData.activeKey = (
            (this.props.location || {}).state || {}
          ).activeKey;
          if (!state.tabData.activeKey) {
            state.tabData.activeKey = "0";
          }
          stateStore.jobSearch = {
            ...state,
            printDataLoading: false,
            printIsDisabled: false,
            reportViewerIsHidden: true,
          };
          this.setState(state, async () => {
            await this.onBuildingChange(this.state.buildingData.selectedValue);
            this.onSearchClicked();
          });
        }
      });
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.controller.abort();
  }

  onPrint = async (reportName = "", exportFormat = "pdf") => {
    this.setState({ printDataLoading: true, printIsDisabled: true });
    let query = `?exportFormat=${exportFormat}&reportName=${reportName}&`;
    const lists = { ...this.parseSearchQueries() };
    for (let key in lists) {
      query += lists[key] !== undefined ? key + "=" + lists[key] + "&" : "";
    }
    query = query.length > 1 ? query.slice(0, query.length - 1) : "";
    axiosInstance
      .get(complaint + "/report" + query, {
        signal: this.controller.signal,
      })
      .then((res) => {
        if ((res.data || {}).success === false) {
          this.setState({ printDataLoading: false, printIsDisabled: false });
          return notification.error({
            message: "Fail",
            description: res.data.message || "Something went wrong !",
          });
        }
        let element = document.createElement("a");
        element.setAttribute(
          "href",
          complaint +
            "/report?filename=" +
            res.data.message +
            "&token=" +
            encodedToken.value
        );
        element.setAttribute("target", "_blank");
        element.setAttribute("rel", "noopener noreferrer");
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
        this.setState({ printDataLoading: false, printIsDisabled: false });
      })
      .catch((err) => {
        this.setState({ printDataLoading: false, printIsDisabled: false });
      });
  };

  render() {
    return (
      <div
        className="site-layout-background"
        style={{
          margin: "0px 0px",
          padding: 5,
          // minHeight: 700,
          width: "100%",
        }}
      >
        <Spin
          spinning={this.state.tableIsLoading}
          tip="fetching and populating data..."
        >
          <Row style={{ marginTop: 10 }}>
            <Col span={8} style={{ textAlign: "left" }}>
              {this.state.parent ? (
                <Button
                  onClick={() =>
                    stateStore.navAble
                      ? stateStore.navAble({
                          defaultSelectedKeys: [this.state.parent],
                          routableProps: {
                            state: { data: [], ComplaintID: null },
                          },
                        })
                      : null
                  }
                >
                  {"<"}
                </Button>
              ) : null}
              {/* <Switch
              checkedChildren="In House"
              unCheckedChildren="Third Party"
              checked={this.state.inHouse}
              onChange={(checked, _) => this.setState({ inHouse: checked })}
            /> */}
            </Col>
            <Col span={8} style={{ textAlign: "center" }}>
              <h3>Job Search</h3>
            </Col>
          </Row>
          <Row gutter={48} style={{ marginTop: 20 }}>
            {/* <Col span={12} xs={24} sm={24} md={24} lg={12}>
              <Row gutter={12}>
                <Col span={24}></Col>
                <Col span={24}>
                  <Card
                    style={{
                      boxShadow: "0 4px 8px 0 rgba(0,0,0,0.4)",
                      transition: "0.3s",
                      // borderRadius: 20,
                      width: "100%",
                    }}
                    bodyStyle={{ padding: 10 }}
                  >
                    <DualAxes
                      data={[
                        this.state.dualVisualizationData.sort(
                          (a, b) => new Date(a.Date) - new Date(b.Date)
                        ),
                        this.state.dualVisualizationData.sort(
                          (a, b) => new Date(a.Date) - new Date(b.Date)
                        ),
                      ]}
                      xField="Date"
                      yField={["Issued", "Solved"]}
                      // (innerHeight-headerFooter-viewSearchRow)/2-(marginTop-for-Column+legend)
                      height={
                        (window.innerHeight - 98 - 50) / 2 - 100 < 305
                          ? 305
                          : (window.innerHeight - 98 - 50) / 2 - 100
                      }
                      geometryOptions={[
                        {
                          geometry: "line",
                          color: "#5B8FF9",
                        },
                        {
                          geometry: "line",
                          color: "#5AD8A6",
                        },
                      ]}
                    />
                  </Card>
                </Col>
                <Col span={24} style={{ marginTop: 30 }}>
                  <Card
                    style={{
                      boxShadow: "0 4px 8px 0 rgba(0,0,0,0.4)",
                      transition: "0.3s",
                      // borderRadius: 20,
                      width: "100%",
                    }}
                    bodyStyle={{ padding: 10, paddingBottom: 0 }}
                  >
                    <Column
                      {...{
                        data: this.state.multipleVisualizationData.sort(
                          (a, b) => new Date(a.Date) - new Date(b.Date)
                        ),
                        isGroup: true,
                        xField: "Date",
                        yField: "Value",
                        seriesField: "BuildingName",
                        label: {
                          position: "bottom",
                          layout: [
                            {
                              type: "interval-adjust-position",
                            },
                            {
                              type: "interval-hide-overlap",
                            },
                            {
                              type: "adjust-color",
                            },
                          ],
                        },
                        slider: {
                          start: 0,
                          end: 1,
                        },
                        // (innerHeight-headerFooter-viewSearchRow)/2-marginTop-for-Column
                        height:
                          (window.innerHeight - 98 - 50) / 2 < 305
                            ? 305
                            : (window.innerHeight - 98 - 80) / 2,
                      }}
                    />
                  </Card>
                </Col>
              </Row>
            </Col> */}
            <Col
              span={0}
              xs={24}
              sm={24}
              md={0}
              lg={0}
              style={{ marginTop: 10 }}
            ></Col>
            {this.state.tableData.list.length ? (
              <Col
                span={0}
                xs={24}
                sm={24}
                md={24}
                lg={0}
                style={{ marginTop: 30 }}
              ></Col>
            ) : null}
            <Col
              {...{ span: 24, xs: 24, sm: 24, md: 24, lg: 24 }}
              // {...{ span: 12, xs: 24, sm: 24, md: 24, lg: 12 }}
              // {...(this.state.tableData.list.length
              //   ? { span: 12, xs: 24, sm: 24, md: 24, lg: 12 }
              //   : { span: 24 })}
            >
              <Row
                style={{
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.4)",
                  transition: "0.3s",
                  borderRadius: 20,
                  width: "100%",
                }}
              >
                <Col
                  span={16}
                  xs={{ span: 16 }}
                  sm={{ span: 16 }}
                  md={{ span: 16 }}
                  lg={{ span: 16 }}
                >
                  <Button
                    icon={<SearchOutlined style={{ color: "green" }} />}
                    style={{
                      width: "100%",
                      borderTopLeftRadius: 20,
                    }}
                    onClick={() => {
                      if (
                        decodedToken.value.activeKey === "employee" &&
                        decodedToken.value.User_ID !== 1 &&
                        stateStore.permissions[69] &&
                        stateStore.permissions[69].UAdd === "N"
                      )
                        return;
                      else this.setState({ modalIsVisible: true });
                    }}
                    disabled={
                      decodedToken.value.activeKey === "employee" &&
                      decodedToken.value.User_ID !== 1 &&
                      stateStore.permissions[69] &&
                      stateStore.permissions[69].UAdd === "N"
                    }
                  >
                    Search
                  </Button>
                </Col>
                <Col
                  span={6}
                  xs={{ span: 8 }}
                  sm={{ span: 8 }}
                  md={{ span: 8 }}
                  lg={{ span: 8 }}
                >
                  <Spin spinning={this.state.printDataLoading}>
                    <Row>
                      <Col span={12}>
                        <Button
                          icon={
                            <FilePdfOutlined style={{ color: "#1890ff" }} />
                          }
                          style={{
                            width: "100%",
                            // borderTopRightRadius: 20,
                          }}
                          onClick={() => this.onPrint("", "pdf")}
                          disabled={
                            this.state.printIsDisabled ||
                            (decodedToken.value.activeKey === "employee" &&
                              decodedToken.value.User_ID !== 1 &&
                              stateStore.permissions[69] &&
                              stateStore.permissions[69].UPrint === "N")
                          }
                        >
                          PDF
                        </Button>
                      </Col>
                      <Col span={12}>
                        <Button
                          icon={
                            <FileExcelOutlined style={{ color: "#1890ff" }} />
                          }
                          style={{
                            width: "100%",
                            borderTopRightRadius: 20,
                          }}
                          onClick={() =>
                            this.onPrint("rptRentalComplaintDetail", "EXCEL")
                          }
                          disabled={
                            this.state.printIsDisabled ||
                            (decodedToken.value.activeKey === "employee" &&
                              decodedToken.value.User_ID !== 1 &&
                              stateStore.permissions[69] &&
                              stateStore.permissions[69].UPrint === "N")
                          }
                        >
                          Excel
                        </Button>
                      </Col>
                    </Row>
                  </Spin>
                </Col>
                <Col span={24}>
                  <Tabs
                    defaultActiveKey="0"
                    activeKey={this.state.tabData.activeKey}
                    onChange={(key) => {
                      let state = this.state;
                      state.tabData.activeKey = String(key);
                      this.setState(state, () => this.onSearchClicked());
                    }}
                    style={{
                      padding: 5,
                      borderTop: "1px solid #f0f0f0",
                      // maxHeight: 200,
                    }}
                  >
                    <Tabs.TabPane tab="New Request" key="0"></Tabs.TabPane>
                    <Tabs.TabPane tab="In Progress" key="1"></Tabs.TabPane>
                    <Tabs.TabPane tab="Rejected" key="2"></Tabs.TabPane>
                    <Tabs.TabPane tab="Closed" key="3"></Tabs.TabPane>
                    <Tabs.TabPane tab="All" key="4"></Tabs.TabPane>
                  </Tabs>
                </Col>
                <Col span={24}>
                  <div
                    ref={(e) => (this.tableRef = e ? e : null)}
                    id="tableClass"
                    style={{ width: "100%", height: "100%" }}
                  >
                    <Table
                      // loading={this.state.tableIsLoading}
                      scroll={{
                        scrollToFirstRowOnChange: false,
                        x: "100",
                        y:
                          window.innerHeight - 405 < 220
                            ? 455
                            : window.innerHeight - 405,
                      }}
                      align="center"
                      size="small"
                      columns={this.columns}
                      dataSource={this.state.tableData.list}
                      pagination={{
                        size: "small",
                        disabled: false,
                        pageSize: this.state.tableData.pageSize,
                        showQuickJumper: true,
                        showSizeChanger: true,
                        // total: this.state.tableData.list.length,
                        total: this.state.tableData.total,
                        onChange: (page, pageSize) => {
                          let state = this.state;
                          state.tableData.currentPage[
                            this.state.tabData.activeKey
                          ] = page;
                          state.tableData.pageSize = pageSize;
                          this.setState(state, this.onSearchClicked);
                        },
                      }}
                    />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Spin>
        <Modal
          visible={this.state.modalIsVisible}
          title="Search by filter"
          footer={
            <Row gutter={8}>
              <Col span={16} style={{ textAlign: "right" }}></Col>
              <Col span={4} style={{ textAlign: "right" }}>
                <Button onClick={this.onReset}>Reset</Button>
              </Col>
              <Col span={4} style={{ textAlign: "right" }}>
                <Button type="primary" onClick={this.onSearchClicked}>
                  Ok
                </Button>
              </Col>
            </Row>
          }
          onCancel={() => this.setState({ modalIsVisible: false })}
          bodyStyle={{
            overflowY: "scroll",
            overflowX: "hidden",
            height: window.innerHeight / 2,
            paddingRight: 20,
          }}
        >
          <Row style={{ marginBottom: 10 }} gutter={8}>
            <Col
              span={6}
              xs={{ span: 6 }}
              sm={{ span: 6 }}
              md={{ span: 0 }}
              lg={{ span: 6 }}
              style={{ textAlign: "right" }}
            >
              <label style={this.labelStyle}>Building</label>
            </Col>
            <Col
              span={18}
              xs={{ span: 18 }}
              sm={{ span: 18 }}
              md={{ span: 24 }}
              lg={{ span: 18 }}
            >
              <Select
                showSearch
                allowClear
                mode="multiple"
                suffixIcon={this.state.buildingData.icon}
                style={{ width: "100%" }}
                placeholder="Select a Building"
                optionFilterProp="children"
                onChange={(val) => {
                  if (!(val || []).length)
                    return message.error(
                      "Please select at least one building !"
                    );
                  // this.onChange(val || "building+-");
                  this.onBuildingChange(val);
                }}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                filterSort={(optionA, optionB) =>
                  optionA.children
                    .toLowerCase()
                    .localeCompare(optionB.children.toLowerCase())
                }
                value={this.state.buildingData.selectedValue || []}
              >
                {this.state.buildingData.list.map((building, index) => {
                  return (
                    <Select.Option key={index} value={building.BuildingID}>
                      {building.BuildingName}
                    </Select.Option>
                  );
                })}
              </Select>
            </Col>
          </Row>
          <Row style={{ marginBottom: 10 }} gutter={8}>
            <Col
              span={6}
              xs={{ span: 6 }}
              sm={{ span: 6 }}
              md={{ span: 0 }}
              lg={{ span: 6 }}
              style={{ textAlign: "right" }}
            >
              <label style={this.labelStyle}>Unit</label>
            </Col>
            <Col
              span={18}
              xs={{ span: 18 }}
              sm={{ span: 18 }}
              md={{ span: 24 }}
              lg={{ span: 18 }}
            >
              <Select
                showSearch
                suffixIcon={this.state.unitData.icon}
                style={{ width: "100%" }}
                placeholder="Select a Unit"
                optionFilterProp="children"
                onChange={(val) => this.onChange(val || "unit+-")}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                filterSort={(optionA, optionB) =>
                  optionA.children
                    .toLowerCase()
                    .localeCompare(optionB.children.toLowerCase())
                }
                value={this.state.unitData.selectedValue}
              >
                {this.state.unitData.list.map((unit, index) => {
                  return (
                    <Select.Option
                      key={index}
                      value={"unit+-" + index + "+-" + unit.UnitNo}
                      title={`Building: ${(unit.Building || {}).BuildingName}`}
                    >
                      {unit.UnitNo}
                    </Select.Option>
                  );
                })}
              </Select>
            </Col>
          </Row>
          {/* <Divider style={{ marginTop: 10, marginBottom: 10 }}></Divider> */}
          <Row style={{ marginBottom: 10 }} gutter={8}>
            <Col
              span={6}
              xs={{ span: 6 }}
              sm={{ span: 6 }}
              md={{ span: 0 }}
              lg={{ span: 6 }}
              style={{ textAlign: "right" }}
            >
              <label style={this.labelStyle}>Job Order No.</label>
            </Col>
            <Col
              span={8}
              xs={{ span: 18 }}
              sm={{ span: 18 }}
              md={{ span: 24 }}
              lg={{ span: 18 }}
            >
              <Input
                allowClear
                style={{
                  // ...this.inputStyle,
                  width: "100%",
                }}
                onChange={(val) =>
                  this.setState({
                    jobOrderNo: {
                      selectedValue: val.target.value,
                    },
                  })
                }
                value={this.state.jobOrderNo.selectedValue}
              ></Input>
            </Col>
          </Row>
          <Row style={{ marginBottom: 10 }} gutter={8}>
            <Col
              span={6}
              xs={{ span: 6 }}
              sm={{ span: 6 }}
              md={{ span: 0 }}
              lg={{ span: 6 }}
              style={{ textAlign: "right" }}
            >
              <label style={this.labelStyle}>Job Order Date</label>
            </Col>
            <Col
              span={8}
              xs={{ span: 18 }}
              sm={{ span: 18 }}
              md={{ span: 24 }}
              lg={{ span: 18 }}
            >
              <Tooltip title="Job Order Date Range">
                <DatePicker.RangePicker
                  allowClear
                  allowEmpty={[true, true]}
                  style={{
                    // ...this.inputStyle,
                    width: "100%",
                  }}
                  onChange={(val) =>
                    this.onDateChange({
                      jobOrderDateFrom: {
                        selectedValue: val ? val[0] : val,
                      },
                      jobOrderDateTo: {
                        selectedValue: val ? val[1] : val,
                      },
                    })
                  }
                  value={[
                    this.state.jobOrderDateFrom.selectedValue,
                    this.state.jobOrderDateTo.selectedValue,
                  ]}
                ></DatePicker.RangePicker>
              </Tooltip>
            </Col>
          </Row>
          {/* <Divider style={{ marginTop: 10, marginBottom: 10 }}></Divider> */}
          <Row style={{ marginBottom: 10 }} gutter={8}>
            <Col
              span={6}
              xs={{ span: 6 }}
              sm={{ span: 6 }}
              md={{ span: 0 }}
              lg={{ span: 6 }}
              style={{ textAlign: "right" }}
            >
              <label style={this.labelStyle}>Complaint Type</label>
            </Col>
            <Col
              span={18}
              xs={{ span: 18 }}
              sm={{ span: 18 }}
              md={{ span: 24 }}
              lg={{ span: 18 }}
            >
              <Tooltip title="Complaint Type">
                <Select
                  showSearch
                  style={{
                    // ...this.inputStyle,
                    width: "100%",
                  }}
                  placeholder="Select a complaint type"
                  optionFilterProp="children"
                  onChange={(val) => this.onChange(val || "complaintType+-")}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                  value={this.state.complaintTypeData.selectedValue}
                >
                  {this.state.complaintTypeData.list.map((complaint, index) => {
                    return (
                      <Select.Option
                        key={index}
                        value={
                          "complaintType+-" + index + "+-" + complaint.SysName
                        }
                      >
                        {complaint.SysName}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Tooltip>
            </Col>
          </Row>
          <Row style={{ marginBottom: 10 }} gutter={8}>
            <Col
              span={6}
              xs={{ span: 6 }}
              sm={{ span: 6 }}
              md={{ span: 0 }}
              lg={{ span: 6 }}
              style={{ textAlign: "right" }}
            >
              <label style={this.labelStyle}>Priority</label>
            </Col>
            <Col
              span={18}
              xs={{ span: 18 }}
              sm={{ span: 18 }}
              md={{ span: 24 }}
              lg={{ span: 18 }}
            >
              <Tooltip title="Priority">
                <Select
                  showSearch
                  style={{
                    // ...this.inputStyle,
                    width: "100%",
                  }}
                  placeholder="Select a priority"
                  optionFilterProp="children"
                  onChange={(val) => this.onChange(val || "priority+-")}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                  value={this.state.priorityData.selectedValue}
                >
                  {this.state.priorityData.list.map((priority, index) => {
                    return (
                      <Select.Option
                        key={index}
                        value={"priority+-" + index + "+-" + priority.UserName}
                      >
                        {priority.UserName}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Tooltip>
            </Col>
          </Row>
          <Row style={{ marginBottom: 10 }} gutter={8}>
            <Col
              span={6}
              xs={{ span: 6 }}
              sm={{ span: 6 }}
              md={{ span: 0 }}
              lg={{ span: 6 }}
              style={{ textAlign: "right" }}
            >
              <label style={this.labelStyle}>Technician</label>
            </Col>
            <Col
              span={18}
              xs={{ span: 18 }}
              sm={{ span: 18 }}
              md={{ span: 24 }}
              lg={{ span: 18 }}
            >
              <Tooltip title="Technician">
                <Select
                  showSearch
                  style={{
                    // ...this.inputStyle,
                    width: "100%",
                  }}
                  placeholder="Select a technician"
                  optionFilterProp="children"
                  onChange={(val) => this.onChange(val || "employee+-")}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                  value={this.state.technicianData.selectedValue}
                >
                  {this.state.technicianData.list.map((technician, index) => {
                    return (
                      <Select.Option
                        key={index}
                        value={
                          "employee+-" + index + "+-" + technician.ContactName
                        }
                      >
                        {technician.ContactName}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Tooltip>
            </Col>
          </Row>
          <Row style={{ marginBottom: 10 }} gutter={8}>
            <Col
              span={6}
              xs={{ span: 6 }}
              sm={{ span: 6 }}
              md={{ span: 0 }}
              lg={{ span: 6 }}
              style={{ textAlign: "right" }}
            >
              <label style={this.labelStyle}>Description</label>
            </Col>
            <Col
              span={8}
              xs={{ span: 18 }}
              sm={{ span: 18 }}
              md={{ span: 24 }}
              lg={{ span: 18 }}
            >
              <Tooltip title="Remarks">
                <Input
                  allowClear
                  style={{
                    // ...this.inputStyle,
                    width: "100%",
                  }}
                  onChange={(val) =>
                    this.setState({
                      remarks: {
                        selectedValue: val.target.value,
                      },
                    })
                  }
                  value={this.state.remarks.selectedValue}
                ></Input>
              </Tooltip>
            </Col>
          </Row>
          {/* <Divider style={{ marginTop: 10, marginBottom: 10 }}></Divider> */}
          <Row
            style={{
              marginBottom: 20,
            }}
            gutter={8}
          >
            <Col
              span={6}
              xs={{ span: 6 }}
              sm={{ span: 6 }}
              md={{ span: 2 }}
              lg={{ span: 2 }}
              style={{ textAlign: "right" }}
            ></Col>
            <Col
              span={18}
              xs={{ span: 18 }}
              sm={{ span: 18 }}
              md={{ span: 22 }}
              lg={{ span: 22 }}
              style={{ textAlign: "left" }}
            >
              <Radio.Group
                value={this.state.delNotAllRadio}
                onChange={this.onChange}
              >
                <Radio value="deleted">Deleted</Radio>
                <Radio value="notdeleted">Not Deleted</Radio>
                <Radio value="allstatus">All Status</Radio>
              </Radio.Group>
            </Col>
          </Row>
          <Row
            style={{
              marginBottom: 20,
            }}
            gutter={8}
          >
            <Col
              span={6}
              xs={{ span: 6 }}
              sm={{ span: 6 }}
              md={{ span: 2 }}
              lg={{ span: 2 }}
              style={{ textAlign: "right" }}
            ></Col>
            <Col
              span={18}
              xs={{ span: 18 }}
              sm={{ span: 18 }}
              md={{ span: 22 }}
              lg={{ span: 22 }}
              style={{ textAlign: "left" }}
            >
              <Radio.Group
                value={this.state.contactCompanyRadio}
                onChange={this.onChange}
              >
                <Radio value="contact">Contact</Radio>
                <Radio value="company">Company</Radio>
              </Radio.Group>
            </Col>
          </Row>
          <Row style={{ marginBottom: 20 }} gutter={8}>
            <Col
              span={6}
              xs={{ span: 6 }}
              sm={{ span: 6 }}
              md={{ span: 2 }}
              lg={{ span: 2 }}
              style={{ textAlign: "right" }}
            >
              {/* <label style={this.labelStyle}>Customer</label> */}
            </Col>
            <Col
              span={18}
              xs={{ span: 18 }}
              sm={{ span: 18 }}
              md={{ span: 22 }}
              lg={{ span: 22 }}
            >
              <Tooltip title="Customer">
                <Select
                  showSearch
                  disabled={!this.state.contactCompanyRadio}
                  style={{
                    // ...this.inputStyle,
                    width: "100%",
                  }}
                  placeholder="Select a customer"
                  optionFilterProp="children"
                  onChange={(val) => this.onChange(val || "customer+-")}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                  value={this.state.customerData.selectedValue}
                >
                  {this.state.customerData.list.map((cus, index) => {
                    return (
                      <Select.Option
                        key={index}
                        value={
                          "customer+-" +
                          index +
                          "+-" +
                          (cus.ContactName || cus.CompanyName)
                        }
                      >
                        {cus.ContactName || cus.CompanyName}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Tooltip>
            </Col>
          </Row>
        </Modal>
        <BackTop
          style={{
            height: 40,
            width: 40,
            lineHeight: "40px",
            borderRadius: 20,
            borderWidth: 5,
            backgroundColor: "#001529",
            color: "white",
            textAlign: "center",
            fontSize: 14,
          }}
          target={() => document.getElementById("theBody")}
        >
          <div>
            <ArrowUpOutlined />
          </div>
        </BackTop>
        <iframe
          // hidden={this.state.reportViewerIsHidden}
          hidden
          ref={(e) => (this.reportViewerRef = e ? e : null)}
          title="Report"
          src={this.state.reportURL}
          type="application/pdf"
          // name="Report View"
          width="100%"
          style={{ border: 0 }}
          height={window.innerHeight - 110}
        ></iframe>
      </div>
    );
  }
}

export default withRouter(JobSearch);
